export { fadeInAndOut } from './fadeinandout';
export { slideInAndOutAnimation } from './slideInAndOut';
